module.exports = __webpack_public_path__ + "img/add-dependente-rounded.4c377e09.svg";